import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import Loading from '../common/Loading';
import ModalSheet from 'components/common/ModalSheet';
import {Button} from '@chekinapp/ui';
import {MODAL_FORMS} from './constants';

export const ButtonConfirm = styled(Button)`
  margin-top: 30px;
  max-width: none;

  width: 100%;
  margin-bottom: 28px;
  @media (min-width: ${DEVICE.mobileXL}) {
    margin-bottom: 0;
  }
`;

export const Error = styled.div`
  align-self: baseline;
`;

type ContentProps = {
  $isLoading?: boolean;
};

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  height: ${props => (props.$isLoading ? '110px' : 'auto')};
  transition: opacity 0.3s ease-in-out;
  width: 100%;
  max-width: 500px;

  .loading-spinner {
    @media (min-width: ${DEVICE.laptop}) {
      margin-top: 25px;
      padding: 0;
    }
  }

  @media (min-width: ${DEVICE.laptop}) {
    padding: 0;
  }
`;

export const ErrorContainer = styled.div``;
export const ErrorMessage = styled.div`
  font-family: inherit;
  text-align: left;
  color: #f84b7a;
  font-size: 11px;
`;

export const StyledLoader = styled(Loading)`
  margin-top: 0;

  @media (max-width: ${DEVICE.mobileXL}) {
    margin-top: 25px;
    svg {
      width: 70px;
    }
  }
`;

export const StyledModalSheet = styled(ModalSheet)<{
  modalSection: MODAL_FORMS;
}>`
  ${props =>
    props.modalSection === MODAL_FORMS.reservationType &&
    css`
      &-content {
        width: 404px;
        & .modal__title {
          margin-bottom: 32px;
        }
      }
    `}

  ${props =>
    props.modalSection === MODAL_FORMS.confirmLeaderGuest &&
    css`
      &-content {
        width: 375px;
      }
    `}
`;

export const RadiosContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
  & .multi-radio {
    gap: 16px;
  }

  & .multi-radio__label {
    color: #152946;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const ConfirmGuestText = styled.div`
  margin-bottom: 40px;
  margin-top: 28px;
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.fontPrimary : '#152946'};
  @media (min-width: ${DEVICE.mobileXL}) {
    margin-top: 0;
  }
`;
